import React from 'react';
import {
  FindingsLogStyleConfig,
  HeaderStyleConfig,
} from '../../../utils/api/pdfLayout';
import { StyleFields } from './SectionStyleControls';
import SectionBodyControls from './SectionBodyControls';

interface Props {
  config: FindingsLogStyleConfig;
  onChange: (fields: Partial<FindingsLogStyleConfig>) => void;
}

const HEADER_FIELDS = ['fontStyle', 'fontSize', 'color', 'backgroundColor'];

// SW2-2344: findings log header style, appearance / text / padding, Open/Closed split,
// and optional columns. All of it prints in both Default and Custom placement.
const FindingsLogStyleControls: React.FC<Props> = ({ config, onChange }) => {
  const columns = config.columns ?? {};

  return (
    <div className='ple-section-style'>
      <span className='ple-section-style__label'>Findings Log</span>
      <div className='ple-section-style__row'>
        <StyleFields
          label='Header'
          fields={HEADER_FIELDS}
          value={config.header_style ?? {}}
          onChange={(header_style: HeaderStyleConfig) => onChange({ header_style })}
        />
      </div>
      <SectionBodyControls
        label='Findings Log'
        appearance={config.appearance}
        bodyStyle={config.body_style ?? {}}
        paddingTip='The height of each row in the findings table.'
        onChange={onChange}
      />
      <div className='ple-section-style__row'>
        <div className='ple-field'>
          <span className='ple-field__label'>Split into Open / Closed sections</span>
          <label className='ple-toggle'>
            <input
              type='checkbox'
              checked={!!config.split_open_closed}
              onChange={(e) => onChange({ split_open_closed: e.target.checked })}
            />
            <span className='ple-toggle__track' />
          </label>
        </div>
        <div className='ple-field'>
          <span className='ple-field__label'>Show "Initiated By" column</span>
          <label className='ple-toggle'>
            <input
              type='checkbox'
              checked={!!columns.initiated_by}
              onChange={(e) =>
                onChange({ columns: { ...columns, initiated_by: e.target.checked } })
              }
            />
            <span className='ple-toggle__track' />
          </label>
        </div>
        <div className='ple-field'>
          <span className='ple-field__label'>Show "Closed By" column</span>
          <label className='ple-toggle'>
            <input
              type='checkbox'
              checked={!!columns.closed_by}
              onChange={(e) =>
                onChange({ columns: { ...columns, closed_by: e.target.checked } })
              }
            />
            <span className='ple-toggle__track' />
          </label>
        </div>
      </div>
    </div>
  );
};

export default FindingsLogStyleControls;
